import * as React from 'react';
import { useMemo, useCallback } from 'react';
import AddToCalendar from 'react-add-to-calendar';
import { css } from '@emotion/core';
import LocalDiv from '../localization/LocalDiv';
import moment from 'moment';
import { SELECT } from './styles/select';
import { COLORS } from '../globalStyle/colors';
import arrow from '../assets/triangle-down-white.svg';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';
import { BENCHMARKS } from '../language/time';
import { doNothing } from '../language/module';


const CALENDARS = [
  { google: 'Google' },
  { outlook: 'Outlook' },
  { yahoo: 'Yahoo' },
];


const styles = {
  root: [
    SELECT,
    css`
      background-color: ${COLORS.BLUE};
      background-image: url(${arrow});
    `,
  ],
  disabled: css`
    opacity: 0.4;
    color: ${COLORS.WHITE};
    line-height: 34px;
  `,
};


type Props = {
  selectedDate: Date;
  className?: string;
};


/**
 * AddToCalendar: a component that renders a dropdown of calendar options for adding a date to the user's calendar
 */
const AddToCalendarBtn: React.FC<Props> = props => {
  const btnText = useMsgText(Str.AddCalendar);

  // We hack the calendar button into a select, but we still have to register a click when the whole mock select is
  // clicked. This finds the link inside the calendar button and clicks it.
  const onClick = useCallback(event => event.target?.children[0]?.getElementsByTagName?.('a')?.[0]?.click?.(), []);

  const event = useMemo(
    () => ({
      title:       '',
      description: '',
      location:    '',
      startTime:   props.selectedDate,
      endTime:     moment(props.selectedDate).add(1, 'days').toDate(),
    }),
    [props.selectedDate],
  );

  const noDate = useMemo(
    () => (
      props.selectedDate.valueOf() === BENCHMARKS.Y2K.valueOf()
    ),
    [props.selectedDate],
  );

  return (
    <LocalDiv
      css={[styles.root, noDate && styles.disabled]}
      className={props.className}
      tabIndex={0}
      onClick={noDate ? doNothing : onClick}
    >
      {/* NOTE: you can't style AddToCalendar normally -- you have to use globalStyles/react-add-to-calendar.css */}
      {
        noDate
        ? (
          <span>{btnText}</span>          
        )
        : (
          <AddToCalendar event={event} listItems={CALENDARS} buttonLabel={btnText} />
        )
      }

    </LocalDiv>
  );
};

export default AddToCalendarBtn;
